export interface PvsComparisonSettings {
    pvsCommissionPercent?: number;
    pvsCostPerInvoice?:    number;
    pvsCostPerMonth?:      number;
}

export interface PvsComparisonResult {
    pvsCost: number;
    savings: number;
}

/** Mirrors backend/src/services/pvsComparison.ts's computePvsComparison exactly, so the live card on
 *  the Charges page and the emailed figure never silently drift apart. Returns null when all three
 *  configured values are 0 ("not configured" — no comparison to show). */
export function computePvsComparison(
    settings: PvsComparisonSettings | null | undefined,
    invoiceCount: number,
    invoiceAmount: number,
    medinvoiceNetTotal: number,
): PvsComparisonResult | null {
    const commissionPercent = settings?.pvsCommissionPercent ?? 0;
    const costPerInvoice    = settings?.pvsCostPerInvoice    ?? 0;
    const costPerMonth      = settings?.pvsCostPerMonth      ?? 0;
    if (commissionPercent <= 0 && costPerInvoice <= 0 && costPerMonth <= 0) return null;

    const pvsCost = +(
        (invoiceAmount * commissionPercent / 100) +
        (invoiceCount * costPerInvoice) +
        costPerMonth
    ).toFixed(2);

    return { pvsCost, savings: +(pvsCost - medinvoiceNetTotal).toFixed(2) };
}
